<template>
	<div :class="$style['app-grid']">
		<div
			v-if="showEditColumns"
			:class="$style['app-grid__toolbar']"
		>
			<BaseIconButton
				v-if="computedActions.length"
				v-testid="'app-grid__actions'"
				:class="$style['app-grid__actions']"
				@click.stop="dropdownToggle"
			>
				<FontAwesomeIcon
					:icon="['fal', 'ellipsis-v']"
					size="lg"
				/>
			</BaseIconButton>
			<DropdownMenu
				ref="dropdown"
				:class="$style['app-table-row__dropbox']"
			>
				<DropdownMenuList
					v-testid="'edit-table'"
					:list="computedActions"
					@dropdown-toggle="dropdownToggle"
				/>
			</DropdownMenu>
		</div>
		<ListTransition
			:time-in="45"
			tag="Grid"
		>
			<slot />
		</ListTransition>
		<ListTransition
			v-if="isRequesting"
			:time-in="45"
			tag="Grid"
		>
			<GridColumn
				v-for="n in skeletonCount"
				:key="`skeleton-${n}`"
				:class="$style['app-grid__skeleton-column']"
				:xs="12"
				:md="6"
				:lg="4"
				:xl="3"
			>
				<GridBoxSkeleton />
			</GridColumn>
		</ListTransition>
		<div
			v-if="!isRequesting && noData"
			:class="$style['app-grid__no-results']"
		>
			<slot name="no-results">
				<span>{{ $t('common.no-results') }}</span>
			</slot>
		</div>
		<BaseTableFooter
			v-if="showFooter && !isRequesting"
			:page="page"
			:per-page="perPage"
			:pages="pages"
			:total="total"
			:meta="meta"
			:show-page-options="showPageOptions"
			display-type="grid"
			clean
			@display-type-change="$emit('display-type-change', $event)"
			@per-page-change="$emit('per-page-change', $event)"
			@page-change="$emit('page-change', $event)"
		/>
		<EditTableModal
			v-if="showEditTableModal"
			:original-list="originalColumns"
			:loading="isRequesting"
			:saved-list="columns"
			:save="handleSaveColumns"
			@modal-toggle="showEditTableModal = false"
		/>
	</div>
</template>

<script>
import ListTransition from '@/components/Transitions/ListTransistion'
import GridBoxSkeleton from '@/components/Global/BaseGridBox/GridBoxSkeleton'
import EditTableModal from '@/components/Layout/EditTableModal'
import DropdownMenu from '@/components/Essentials/DropdownMenu'
import DropdownMenuList from '@/components/Essentials/DropdownMenu/DropdownMenuList'

export default {
	name: 'BaseGrid',
	components: {
		ListTransition,
		GridBoxSkeleton,
		EditTableModal,
		DropdownMenu,
		DropdownMenuList
	},
	props: {
		page: {
			type: [String, Number],
			default: 1
		},
		perPage: {
			type: [String, Number],
			default: 5
		},
		pages: {
			type: [String, Number],
			default: 0
		},
		total: {
			type: [String, Number],
			default: 0
		},
		meta: {
			type: Object,
			default: () => ({})
		},
		showFooter: {
			type: Boolean,
			default: true
		},
		showPageOptions: {
			type: Boolean,
			default: true
		},
		showEditColumns: {
			type: Boolean,
			default: false
		},
		columns: {
			type: Array,
			default: () => []
		},
		originalColumns: {
			type: Array,
			default: () => []
		},
		actions: {
			type: Array,
			default: () => []
		},
		isRequesting: {
			type: Boolean,
			default: false
		},
		skeletonCount: {
			type: Number,
			default: 8
		},
		noData: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			showEditTableModal: false
		}
	},

	computed: {
		computedActions () {

			if (this.actions && this.actions.length) {
				return this.actions
			}

			if (this.showEditColumns) {
				return [
					{
						title: this.$t('common.buttons.edit'),
						click: () => {
							this.showEditTableModal = true
						}
					}
				]
			}
			return []
		}
	},
	methods: {
		dropdownToggle () {
			this.$refs.dropdown.toggle()
		},
		handleSaveColumns (newColumns) {
			this.showEditTableModal = false
			this.$emit('save-columns', newColumns)
		}
	}
}
</script>

<style lang="scss" module>
	.app-grid {
		width: 100%;
		margin-bottom: 20px;

		&__toolbar {
			display: flex;
			justify-content: flex-end;
			margin-bottom: $gutter;
		}

		&__actions {
			margin: $gutter * 2 0;
		}

		&__skeleton-column {
			margin-bottom: $gutter * 2;
			padding: 0 12.5px;

			@include media-breakpoint-down(sm) {
				margin-bottom: $gutter;
			}
		}

		&__no-results {
			width: 100%;
			display: flex;
			justify-content: center;
			padding: $gutter * 2;
			margin-bottom: $gutter * 2;
			font-size: 14px;
			color: getColor(helper-text);
		}
	}
</style>
